(function($) {
	$(function() {
		$('.block-hero-slider').owlCarousel({
			items: 1,
			nav: true,
			dots: false,
			mouseDrag: false,
			lazyLoad: true,
			lazyLoadEager: true,
			animateOut: 'fadeOut',
			navSpeed: 100,
			loop: true,
			navText: [
				'<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve">\
				<g>\
					<path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225\
						c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"></path>\
				</g>\
				</svg>',
				'<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\
				viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve">\
				<g>\
					<path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5\
						c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z\
						"/>\
				</g>\
				</svg>'
			]
		});

		$('.nav-toggle').click( () => $('body').toggleClass('nav-opened') );

		// Active nav on project inner
		if( $('body').hasClass('single-projekti') ) {
			$('#menu-item-528').addClass('current-menu-item');
		}

		/*
		** Lightbox
		*/

		var
			// ACTIVITY INDICATOR
			activityIndicatorOn = function() {
				$( '<div id="imagelightbox-loading"><div></div></div>' ).appendTo( 'body' );
			},
			activityIndicatorOff = function() {
				$( '#imagelightbox-loading' ).remove();
			},

		// OVERLAY
		overlayOn = function() {
			$( '<div id="imagelightbox-overlay"></div>' ).appendTo( 'body' );
		},
		overlayOff = function() {
			$( '#imagelightbox-overlay' ).remove();
		},

		// CLOSE BUTTON
		closeButtonOn = function( instance ) {
			$( '<button type="button" id="imagelightbox-close" title="Close"></button>' ).appendTo( 'body' ).on( 'click touchend', function(){ $( this ).remove(); instance.quitImageLightbox(); return false; });
		},
		closeButtonOff = function() {
			$( '#imagelightbox-close' ).remove();
		},

		// CAPTION
		captionOn = function() {
			var description = '';
			if( description.length > 0 )
				$( '<div id="imagelightbox-caption">' + description + '</div>' ).appendTo( 'body' );
		},
		captionOff = function() {
			$( '#imagelightbox-caption' ).remove();
		},


		// ARROWS
		arrowsOn = function( instance, selector ) {
			var $arrows = $( '<button type="button" class="imagelightbox-arrow imagelightbox-arrow-left"></button><button type="button" class="imagelightbox-arrow imagelightbox-arrow-right"></button>' );

			$arrows.appendTo( 'body' );

			$arrows.on( 'click touchend', function( e ) {
				e.preventDefault();

				var $this	= $( this ),
					$target	= $( selector + '[href="' + $( '#imagelightbox' ).attr( 'src' ) + '"]' ),
					index	= $target.index( selector );

				if( $this.hasClass( 'imagelightbox-arrow-left' ) ) {
					index = index - 1;
					if( !$( selector ).eq( index ).length )
						index = $( selector ).length;
				} else {
					index = index + 1;
					if( !$( selector ).eq( index ).length )
						index = 0;
				}

				instance.switchImageLightbox( index );
				return false;
			});
		},
		arrowsOff = function() {
			$( '.imagelightbox-arrow' ).remove();
		};
		
		var selectorF = 'a[data-imagelightbox="f"]';
		var instanceF = $( selectorF ).imageLightbox({
				onStart:		function() { overlayOn(); closeButtonOn( instanceF ); arrowsOn( instanceF, selectorF ); },
				onEnd:			function() { overlayOff(); captionOff(); closeButtonOff(); arrowsOff(); activityIndicatorOff(); },
				onLoadStart: 	function() { captionOff(); activityIndicatorOn(); },
				onLoadEnd:	 	function() { captionOn(); activityIndicatorOff(); $( '.imagelightbox-arrow' ).css( 'display', 'block' ); }
		});

		// Sub nav
		$('.menu-item-has-children').on('click', e => {
			let parentUl = e.target.parentNode.parentNode.parentNode;

			if ( !parentUl.classList.contains('sub-menu') ) {
				e.preventDefault();
			}
		});

		var windowHeight = "innerHeight" in window 
			? window.innerHeight
			: document.documentElement.offsetHeight; 

		if ( $('body').height() < (windowHeight - 100) ) {
			$('#footer').addClass('fixed');
		}


	});
})( jQuery );